//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["part"],"ValidatePmi",{},1,0],[["part","numResults","jsonString"],"GetValidationResults",{R_:{pmiList:"Annotations.Pmi[]"}},1,0],[[],"GetAdvisorChecks",{R_:{jsonString:''}},0,0],[[],"GetStandards",{R_:{jsonString:''}},0,0],[["standard"],"SetActiveStandard",{},1,0],[["part"],"CreateVisualTagSymbolsInPart",{},1,0],[["part"],"DeleteVisualTagSymbolsInPart",{},1,0]],[]];
SPLM.MBD.WebAdvisor = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebAdvisor";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;